module.exports = __webpack_public_path__ + "static/img/paidssss3@3x.225c7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paidssss3@3x.png
// module id = PLFh
// module chunks = 1